import * as React from "react"
import {SelectSeeker} from "@ui-seeker/core";

import {VALIDATED} from "@constants"
import {validated} from "@signals"


export const OPTIONS = [
	{ label: 'Validated', value: VALIDATED.VALIDATED },
	{ label: 'Non Validated', value: VALIDATED.NON_VALIDATED }
]

export default function DIPValidatedSelect({ ...props }) {
	return <SelectSeeker
		multiple
		options={OPTIONS}
		label="Validated"
		value={validated.value}
		onChange={e => validated.value = e.target.value}
		{...props}
	/>
}